module.exports = __webpack_public_path__ + "img/解决方案_EMS_绿.89db9480.svg";